import React, { useState } from 'react'
import BootstrapTable from "react-bootstrap-table-next"
import { Button } from 'react-bootstrap'
import cellEditFactory, { Type } from 'react-bootstrap-table2-editor';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';


export const TagProductsView = (props) => {
  console.log(props)

  const columns = [{
    dataField: 'parentId',
    text: 'Parent Id',
    editable: false
  }, {
    dataField: 'id',
    text: 'Product ID',
    formatter: (cell) => <a href={`https://h.merchoid.com/admin5YodaRed5Palpatine2/?page=inventoryEdit&productId=${cell}`}>{cell}</a>,
    editable: false
  }, {
    dataField: 'productName',
    text: 'Product Name',
    filter: textFilter(),
    editable: false
  }, {
    dataField: 'productCost',
    text: 'Cost',
    editable: false,
    formatter: (cell) => '£' + cell.toFixed(2)
  }, {
    dataField: 'supplierCode',
    text: 'Supplier Name',
    editable: true,
    editor: {
      type: Type.SELECT,
      options: !props.loading && props.suppliers.map((supplier, index) => ({
        value: supplier.id,
        label: supplier.supplierName
      })),
    },
    formatter: (cell, row) => {
      // Ensure cell (supplierCode) is a string for proper comparison
      const supplier = props.suppliers.find(s => s.id === String(cell));
      return supplier ? supplier.supplierName : 'Unknown'; // 'Unknown' is a fallback in case the supplier is not found
    },
  }, {
    dataField: 'productBrand',
    text: 'Brand',
    filter: textFilter(),
    editor: {
      type: Type.SELECT,
      options: !props.loading && props.brands.map((brand, index) => ({
        value: brand,
        label: brand
      }))
    }
  }, {
    dataField: 'productCategory',
    filter: textFilter(),
    text: 'Categories',
    editor: {
      type: Type.SELECT,
      options: !props.loading && props.categories.map((category, index) => ({
        value: category,
        label: category,
      }))
    }
  }, {
    dataField: 'submit',
    isDummyField: true,
    text: 'Submit',
    formatter: (cell, row) => {
      return (
        <Button
          onClick={() => props.onClickSubmit(row)}
          disabled={row.status === 'Saved'}
        >
          {row.status || 'Save'}
        </Button>
      );
    },
    editable: false,
  }

  ]



  return <div>
    {!props.loading && <BootstrapTable
      key='id'
      keyField='id'
      data={props.products}
      columns={columns}
      cellEdit={cellEditFactory({ mode: 'click', blurToSave: true })}
      filter={filterFactory()}
      {...props.baseProps}
      pagination={paginationFactory({
        sizePerPageList: [{
          text: '100', value: 100
        }, {
          text: '200', value: 200
        }, {
          text: 'All', value: props.products.length
        }]
      })}
    />}


  </div>
}